import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestMeetingCheckItemsEnum as MeetingItemEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  MEETING_ITEM_MAX,
  MEETING_ITEM_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";

import { useStepStyles } from "./stepStyles";

type MeetingItemsStepProps = {
  meetingCheckItems: MeetingItemEnum[];
  onMeetingCheckItemsChange: (next: MeetingItemEnum[]) => void;
};

const MeetingItemsStep: React.FC<MeetingItemsStepProps> = ({ meetingCheckItems, onMeetingCheckItemsChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>プランナーに相談したいこと</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[16]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={MEETING_ITEM_OPTIONS}
          selected={meetingCheckItems}
          max={MEETING_ITEM_MAX}
          onChange={onMeetingCheckItemsChange}
        />
      </Box>
    </>
  );
};

export default MeetingItemsStep;
